module.exports = __webpack_public_path__ + "img/calendar-presentase.ba6026c5.svg";